/**
 * Created by lu on 2018/4/24.
 */
var language = {
    cn: {
        recycleText: '回收站',
        statusMap: {
            1: {
                statusText: '待付款'
            },
            2: {
                statusText: '凭证审核中'
            },
            3: {
                statusText: '待发货'
            },
            4: {
                statusText: '待发货' //开始拣货
            },
            5: {
                statusText: '待发货' //拣货完成
            },
            6: {
                statusText: '待收货'
            },
            7: {
                statusText: '完成'
            },
            8: {
                statusText: '待退款'
            },
            9: {
                statusText: '完成退款'
            },
            10: {
                statusText: '已失效'
            },
            11: {
                statusText: '删除'
            },
            12: {
                statusText: '申请退货'
            },
            13: {
                statusText: '拒绝退货'
            },
            14: {
                statusText: '待退货'
            },
            15: {
                statusText: '已退货'
            },
            16: {
                statusText: '已取消'
            },
            17: {
                statusText: '全部拒收'
            },
            18: {
                statusText: '部分拒收'
            },
            19: {
                statusText: '已锁定'
            }

        },
        tabList: {
            items: [{
                status: 0,
                text: '所有订单'
            }, {
                status: 1,
                text: '待付款'
            }, {
                status: 2,
                text: '已付款'
            }, {
                status: 3,
                text: '待收货'
            }, {
                status: 4,
                text: '已完成'
            }],
            activeIndex: 0
        },
        orderScreen: {
            orderNum: {
                inputBorder: '',
                type: 'text',
                placeholder: '请输入订单号',
                maxlength: '30'
            },
            productName: {
                inputBorder: '',
                type: 'text',
                placeholder: '请输入商品名称',
                maxlength: '30'
            },
            screenText: '搜索',
            orderNumText: '订单号',
            productNameText: '商品名称',
            payWayText: '支付方式：',
            orderTime: '订单日期'
        },
        orderNav: {
            goods: '商品信息',
            spec: '商品规格',
            price: '单价',
            num: '数量',
            count: '小计',
            state: '状态',
            operation: '操作'
        },
        orderList: {
            list: {
                itemText: {
                    orderNoText: '订单号：',
                    salesNameText: '下单销售：',
                    totalText: '订单总金额：',
                    payWayText: '支付方式：',
                    text: '订单详情',
                    seeMore: '查看更多商品>>',
                    goPayText: '立即付款',
                    affirmText: '确认收货',
                    logisticsText: '查看物流',
                    cancelText: '取消订单',
                    deleteText: '删除订单',
                    afterSaleText: '退货退款'
                }
            }
        }
    },
    en: {
        recycleText: 'Recycle',
        statusMap: {
            1: {
                statusText: 'Pending Payment'
            },
            2: {
                statusText: 'Voucher Auditing'
            },
            3: {
                statusText: 'Pending Delivery'
            },
            4: {
                statusText: 'Pending Delivery'
            },
            5: {
                statusText: 'Pending Delivery'
            },
            6: {
                statusText: 'Processing'
            },
            7: {
                statusText: 'Completed'
            },
            8: {
                statusText: 'Pending Refund'
            },
            9: {
                statusText: 'Refund Completed'
            },
            10: {
                statusText: 'Invalid'
            },
            11: {
                statusText: 'Delete'
            },
            12: {
                statusText: 'Refund'
            },
            13: {
                statusText: 'Refund Refused'
            },
            14: {
                statusText: 'Pending Refund'
            },
            15: {
                statusText: 'Refunded'
            },
            16: {
                statusText: 'Canceled'
            },
            17: {
                statusText: 'Complete Rejection'
            },
            18: {
                statusText: 'Partial Rejection'
            },
            19: {
                statusText: 'Already Locked'
            }
        },
        tabList: {
            items: [{
                status: 0,
                text: 'All orders'
            }, {
                status: 1,
                text: 'Pending payment'
            }, {
                status: 2,
                text: 'Paid'
            }, {
                status: 3,
                text: 'Processing'
            }, {
                status: 4,
                text: 'Completed'
            }],
            activeIndex: 0
        },
        orderScreen: {
            orderNum: {
                inputBorder: '',
                type: 'text',
                placeholder: 'Enter order number',
                maxlength: '30'
            },
            productName: {
                inputBorder: '',
                type: 'text',
                placeholder: 'Enter product name',
                maxlength: '30'
            },
            screenText: 'Search',
            orderNumText: 'Order Number',
            productNameText: 'Product Name',
            payWayText: 'Payment Type：',
            orderTime: 'Order Date'
        },
        orderNav: {
            goods: 'Products',
            spec: 'Specifications',
            price: 'Price',
            num: 'Quantity',
            count: 'Subtotal',
            state: 'Status',
            operation: 'Operation'
        },
        orderList: {
            list: {
                itemText: {
                    orderNoText: 'Order Number：',
                    salesNameText: 'Purchase：',
                    totalText: 'Order Amount：',
                    payWayText: 'Payment Type：',
                    text: 'Order Details',
                    seeMore: 'See More',
                    goPayText: 'Payment',
                    affirmText: 'Received',
                    logisticsText: 'Logistics',
                    cancelText: 'Cancel',
                    deleteText: 'Delete',
                    afterSaleText: 'Refund'
                }
            }
        }
    }
};
module.exports = {
    language: language
};

// statusMap: {
//     1: {
//         statusText:'待付款'
//     },
//     2:{
//         statusText:'已取消'
//     },
//     3:{
//         statusText:'待发货'
//     },
//     4:{
//         statusText:'待收货'
//     },
//     5:{
//         statusText:'已完成'
//     },
//     6:{
//         statusText:'待退款'
//     },
//     7:{
//         statusText:'完成退款'
//     },
//     8:{
//         statusText:'已失效'
//     },
//     9:{
//         statusText:'删除'
//     },
//     10:{
//         statusText:'申请退货'
//     },
//     11:{
//         statusText:'拒绝退货'
//     },
//     12:{
//         statusText:'待退货'
//     },
//     13:{
//         statusText:'已退货'
//     },
//     14:{
//         statusText:'凭证审核中'
//     }
// },


//////////////////
// WEBPACK FOOTER
// ../src/js/page/order/config.js
// module id = 687
// module chunks = 3